function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export const PeopleIcon = (_0)=>{
    let { color = '#7B84A3' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    var _props_width, _props_height;
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: (_props_width = props.width) !== null && _props_width !== void 0 ? _props_width : 24,
        height: (_props_height = props.height) !== null && _props_height !== void 0 ? _props_height : 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12.3149 12.22C12.8485 11.7581 13.2765 11.1869 13.5698 10.545C13.8631 9.90316 14.0149 9.20571 14.0149 8.5C14.0149 7.17392 13.4881 5.90215 12.5505 4.96447C11.6128 4.02678 10.341 3.5 9.01492 3.5C7.68884 3.5 6.41707 4.02678 5.47939 4.96447C4.54171 5.90215 4.01492 7.17392 4.01492 8.5C4.01492 9.20571 4.16672 9.90316 4.46005 10.545C4.75337 11.1869 5.18135 11.7581 5.71492 12.22C4.31506 12.8539 3.12739 13.8775 2.2939 15.1685C1.46042 16.4596 1.01639 17.9633 1.01492 19.5C1.01492 19.7652 1.12028 20.0196 1.30782 20.2071C1.49535 20.3946 1.74971 20.5 2.01492 20.5C2.28014 20.5 2.53449 20.3946 2.72203 20.2071C2.90957 20.0196 3.01492 19.7652 3.01492 19.5C3.01492 17.9087 3.64706 16.3826 4.77228 15.2574C5.8975 14.1321 7.42362 13.5 9.01492 13.5C10.6062 13.5 12.1323 14.1321 13.2576 15.2574C14.3828 16.3826 15.0149 17.9087 15.0149 19.5C15.0149 19.7652 15.1203 20.0196 15.3078 20.2071C15.4954 20.3946 15.7497 20.5 16.0149 20.5C16.2801 20.5 16.5345 20.3946 16.722 20.2071C16.9096 20.0196 17.0149 19.7652 17.0149 19.5C17.0135 17.9633 16.5694 16.4596 15.7359 15.1685C14.9025 13.8775 13.7148 12.8539 12.3149 12.22ZM9.01492 11.5C8.42158 11.5 7.84156 11.3241 7.34821 10.9944C6.85486 10.6648 6.47035 10.1962 6.24328 9.64805C6.01622 9.09987 5.95681 8.49667 6.07257 7.91473C6.18832 7.33279 6.47405 6.79824 6.8936 6.37868C7.31316 5.95912 7.84771 5.6734 8.42965 5.55764C9.0116 5.44189 9.61479 5.5013 10.163 5.72836C10.7112 5.95542 11.1797 6.33994 11.5093 6.83329C11.839 7.32664 12.0149 7.90666 12.0149 8.5C12.0149 9.29565 11.6989 10.0587 11.1362 10.6213C10.5736 11.1839 9.81057 11.5 9.01492 11.5ZM18.7549 11.82C19.3949 11.0993 19.8129 10.2091 19.9587 9.25634C20.1045 8.30362 19.9718 7.32907 19.5767 6.45C19.1815 5.57093 18.5407 4.8248 17.7314 4.30142C16.9221 3.77805 15.9787 3.49974 15.0149 3.5C14.7497 3.5 14.4954 3.60536 14.3078 3.79289C14.1203 3.98043 14.0149 4.23478 14.0149 4.5C14.0149 4.76522 14.1203 5.01957 14.3078 5.20711C14.4954 5.39464 14.7497 5.5 15.0149 5.5C15.8106 5.5 16.5736 5.81607 17.1362 6.37868C17.6989 6.94129 18.0149 7.70435 18.0149 8.5C18.0135 9.02524 17.8742 9.5409 17.611 9.99542C17.3477 10.4499 16.9698 10.8274 16.5149 11.09C16.3667 11.1755 16.2428 11.2977 16.1553 11.4447C16.0677 11.5918 16.0194 11.7589 16.0149 11.93C16.0107 12.0998 16.0499 12.2678 16.1286 12.4183C16.2073 12.5687 16.3231 12.6967 16.4649 12.79L16.8549 13.05L16.9849 13.12C18.1903 13.6917 19.2072 14.596 19.9159 15.7263C20.6246 16.8566 20.9955 18.1659 20.9849 19.5C20.9849 19.7652 21.0903 20.0196 21.2778 20.2071C21.4654 20.3946 21.7197 20.5 21.9849 20.5C22.2501 20.5 22.5045 20.3946 22.692 20.2071C22.8796 20.0196 22.9849 19.7652 22.9849 19.5C22.9931 17.9654 22.6087 16.4543 21.8684 15.1101C21.128 13.7659 20.0563 12.6333 18.7549 11.82Z",
            fill: color
        })
    }));
};
